/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AccessPassCoupon } from './AccessPassCoupon';
import { BaseCouponUsage } from './BaseCouponUsage';
const AccessPassCouponUsageParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan')],
    ['coupon', AccessPassCoupon],
]), BaseCouponUsage);
export class AccessPassCouponUsage extends BaseCouponUsage {
    static decode(input) {
        return AccessPassCouponUsageParser.decode(input).map(res => new AccessPassCouponUsage(res));
    }
    static unsafeDecode(input) {
        return AccessPassCouponUsage.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessPassCouponUsageParser.encode(data);
    }
    static schema() {
        return AccessPassCouponUsageParser.schema();
    }
}
